import { reportError } from '@/lib/error-reporter'
import { supabase } from '@/lib/supabase/client'

/**
 * Returns the caller's organization, creating one on the Free plan when they
 * have none. Null when a pending invitation should be accepted instead.
 */
export async function ensureOwnOrganization(): Promise<string | null> {
  const { data, error } = await supabase.rpc('ensure_own_organization')

  if (error) {
    throw new Error(`Failed to set up your organization: ${error.message}`, {
      cause: error,
    })
  }

  return data
}

export async function saveFullName(fullName: string) {
  const {
    data: { user },
  } = await supabase.auth.getUser()
  if (!user) {
    throw new Error('Not signed in')
  }

  const { data, error } = await supabase
    .from('profiles')
    .update({ full_name: fullName })
    .eq('id', user.id)
    .select('*')
    .single()

  if (error) {
    throw new Error(`Failed to save your name: ${error.message}`, {
      cause: error,
    })
  }

  return data
}

/** Adds the person to the Flodesk mailing list without waiting on it. */
export function subscribeToMailingList(email: string, fullName: string) {
  supabase.functions
    .invoke('subscribe-flodesk', { body: { email, full_name: fullName } })
    .catch((error) => reportError(error))
}
